import React, { useEffect, useState } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import { joinUs } from "../api/apiClient";
import { toast } from "react-hot-toast";

const OpenAnAccount = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }

    if (window.initCounterAnimation) {
      window.initCounterAnimation();
    }

    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.length > 255) {
      newErrors.name = "Name must be less than 255 characters";
    }

    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile number is required";
    } else {
      const phoneRegex = /^[6-9]\d{9}$/;
      if (!phoneRegex.test(formData.mobile_number.replace(/\D/g, ""))) {
        newErrors.mobile_number = "Please enter a valid 10-digit mobile number";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.error("Please fix the errors in the form");
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        name: formData.name,
        mobile_number: formData.mobile_number,
      };

      const response = await joinUs(payload);

      toast.success(response?.message || "Thank you for joining us!");
      setFormData({
        name: "",
        mobile_number: "",
      });

      const link = "https://live.meon.co.in/GatewayFInancial/Individual";
      window.open(link, "_blank", "noopener noreferrer");
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="open-account-page">
      <SEO
        title="Open a Demat & Trading Account"
        description="Start your investment journey with Gateway Financial. Open a free demat account in 4 easy steps and access diverse investment opportunities with expert guidance."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: 'url("/images/open-an-account-banner.jpg")',
              }}
            >
              <canvas id="canvas" aria-hidden="true" />
              <div className="carousel-caption">
                <h1 className="mb-lg-4 mb-xl-4">Join Us</h1>
                <form onSubmit={handleSubmit} id="oaa-contact-form" noValidate>
                  <div className="controls">
                    <div className="row mb-lg-2 mb-xl-2">
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="text"
                            placeholder="Enter your name"
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            name="name"
                            id="form_name"
                            value={formData.name}
                            onChange={handleChange}
                          />
                          {errors.name && (
                            <div
                              className="invalid-feedback"
                              style={{
                                display: "block",
                                color: "#fff",
                                fontSize: "12px",
                                marginTop: "5px",
                                textAlign: "left",
                              }}
                            >
                              {errors.name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="tel"
                            placeholder="Enter your mobile number"
                            className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
                            name="mobile_number"
                            id="form_mobile"
                            value={formData.mobile_number}
                            onChange={handleChange}
                          />
                          {errors.mobile_number && (
                            <div
                              className="invalid-feedback"
                              style={{
                                display: "block",
                                color: "#fff",
                                fontSize: "12px",
                                marginTop: "5px",
                                textAlign: "left",
                              }}
                            >
                              {errors.mobile_number}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          type="submit"
                          className="btn2"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Next"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h2>Trade Smarter with Gateway's Stock Broking Platform</h2>
              <p className="spc-txt">
                Build Wealth—We've Seen 5 Market Crashes, 5 Rate Cycles, And
                10,000+ Client Portfolios.
              </p>
            </div>
          </div>
          <div className="row mt-lg-5">
            <div className="col-lg-4">
              <div className="wel-box text-center">
                <div className="wel-box-img">
                  <img
                    src="/images/ia-icon4.png"
                    className="img-fluid"
                    alt="Experience Icon"
                  />
                </div>
                <div className="wel-box-ctn counter-box">
                  <span className="num" data-val={30}>
                    30
                  </span>
                  <span>+</span>
                  <p>Years Experience</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="wel-box text-center">
                <div className="wel-box-img">
                  <img
                    src="/images/ia-icon5.png"
                    className="img-fluid"
                    alt="Customers Icon"
                  />
                </div>
                <div className="wel-box-ctn counter-box">
                  <span className="num" data-val={3000}>
                    3000
                  </span>
                  <span>+</span>
                  <p>Registered Customers</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="wel-box text-center">
                <div className="wel-box-img">
                  <img
                    src="/images/ia-icon6.png"
                    className="img-fluid"
                    alt="Active Users Icon"
                  />
                </div>
                <div className="wel-box-ctn counter-box">
                  <span className="num" data-val={5000}>
                    5000
                  </span>
                  <span>+</span>
                  <p>Active Users</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="checklist-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h3>Documents Checklist To Open A Demat Account</h3>
              <a
                href="https://live.meon.co.in/GatewayFInancial/Individual"
                target="_blank"
                rel="noopener noreferrer"
                className="lm-btn bark-bg"
              >
                Get Started With Your Investment
              </a>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-3">
              <div className="media">
                <img
                  src="/images/checklist-icon1.png"
                  className="mr-3"
                  alt="Identity Proof"
                />
                <div className="media-body align-self-center">
                  <h5 className="mt-0 mb-0">Identity Proof</h5>
                </div>
              </div>
              <div className="media">
                <img
                  src="/images/checklist-icon2.png"
                  className="mr-3"
                  alt="PAN Card"
                />
                <div className="media-body align-self-center">
                  <h5 className="mt-0 mb-0">PAN Card</h5>
                </div>
              </div>
              <div className="media">
                <img
                  src="/images/checklist-icon3.png"
                  className="mr-3"
                  alt="Photographs"
                />
                <div className="media-body align-self-center">
                  <h5 className="mt-0 mb-0">Photographs &amp; Signature</h5>
                </div>
              </div>
              <div className="media">
                <img
                  src="/images/checklist-icon4.png"
                  className="mr-3"
                  alt="Address Proof"
                />
                <div className="media-body align-self-center">
                  <h5 className="mt-0 mb-0">Address Proof</h5>
                </div>
              </div>
              <div className="media">
                <img
                  src="/images/checklist-icon5.png"
                  className="mr-3"
                  alt="Bank Details"
                />
                <div className="media-body align-self-center">
                  <h5 className="mt-0 mb-0">Bank Account Details</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <img
                src="/images/checklist-img.jpg"
                className="img-fluid border-radius-15 w-100"
                alt="Document Checklist"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="step-section">
        <div className="container">
          <div className="row mb-5 justify-content-center">
            <div className="col-lg-10 text-center">
              <h3>Get Your Free Account in 4 Easy Steps</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 text-center">
              <div className="step-box">
                <div className="step-box-img">
                  <img
                    src="/images/step-icon1.png"
                    className="img-fluid m-auto"
                    alt="Step 1"
                  />
                </div>
                <div className="step-box-ctn">
                  <h4>
                    Fill Out The <br />
                    Form
                  </h4>
                  <p>
                    Complete online account form with personal financial
                    details.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 text-center">
              <div className="step-box">
                <div className="step-box-img">
                  <img
                    src="/images/step-icon2.png"
                    className="img-fluid m-auto"
                    alt="Step 2"
                  />
                </div>
                <div className="step-box-ctn">
                  <h4>
                    Verify Your <br />
                    Identity
                  </h4>
                  <p>
                    Upload PAN, Aadhaar, and bank details for KYC verification.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 text-center">
              <div className="step-box">
                <div className="step-box-img">
                  <img
                    src="/images/step-icon3.png"
                    className="img-fluid m-auto"
                    alt="Step 3"
                  />
                </div>
                <div className="step-box-ctn">
                  <h4>eSign Account Opening Documents</h4>
                  <p>
                    Review documents and eSign instantly using Aadhaar
                    authentication.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 text-center">
              <div className="step-box">
                <div className="step-box-img">
                  <img
                    src="/images/step-icon4.png"
                    className="img-fluid m-auto"
                    alt="Step 4"
                  />
                </div>
                <div className="step-box-ctn">
                  <h4>Activate Your Account</h4>
                  <p>
                    Once verified, your trading account is activated so you can
                    start investing right away.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="invested-section">
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center mb-3">
              <h3>Benefits of Demat Account Opening</h3>
              <p className="spc-txt">
                Without further ado, here’s how to start.
              </p>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-lg-4">
              <div className="invest-box text-center ib-min-height">
                <img
                  src="/images/benf-icon1.png"
                  className="img-fluid"
                  alt="Diverse Options"
                />
                <h4>Comprehensive Investment Options</h4>
                <p className="mb-0">
                  Access a wide range of investment avenues including equities,
                  mutual funds, commodities, ETFs, and fixed income instruments
                  through a single demat account.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center ib-min-height">
                <img
                  src="/images/benf-icon2.png"
                  className="img-fluid"
                  alt="Research Advisory"
                />
                <h4>
                  Research and Advisory
                  <br /> Services
                </h4>
                <p className="mb-0">
                  Benefit from timely market insights, fundamental and technical
                  research, and actionable recommendations to support informed
                  investment decisions.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center ib-min-height">
                <img
                  src="/images/benf-icon3.png"
                  className="img-fluid"
                  alt="Customer Support"
                />
                <h4>
                  Dedicated Customer <br />
                  Support
                </h4>
                <p className="mb-0">
                  Receive personalized assistance from experienced relationship
                  managers for account services, transactions, and
                  investment-related queries.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="invest-box text-center ib-min-height">
                <img
                  src="/images/benf-icon4.png"
                  className="img-fluid"
                  alt="Competitive Fees"
                />
                <h4>Competitive Fees</h4>
                <p className="mb-0">
                  Enjoy transparent and cost-effective brokerage and account
                  maintenance charges designed to enhance your overall
                  investment returns.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center ib-min-height">
                <img
                  src="/images/benf-icon5.png"
                  className="img-fluid"
                  alt="Digital Platforms"
                />
                <h4>User-Friendly Digital Platforms</h4>
                <p className="mb-0">
                  Trade seamlessly using secure and intuitive web and mobile
                  platforms equipped with real-time data, advanced tools, and
                  easy portfolio tracking.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center ib-min-height">
                <img
                  src="/images/benf-icon6.png"
                  className="img-fluid"
                  alt="Expert Guidance"
                />
                <h4>Experience The Impact of Expert Guidance</h4>
                <p className="mb-0">
                  Leverage professional market expertise and disciplined
                  investment strategies to build, manage, and grow your
                  portfolio across market cycles.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt-5">
            <div className="col-lg-4">
              <button onClick={handleScrollToTop} className="lm-btn">
                Get Started With Your Investment
              </button>
            </div>
          </div>
        </div>
      </section>

      <section id="service-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center mb-3">
              <h3>One Account, Many Opportunities</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="/images/oa-icon1.png"
                  className="img-fluid"
                  alt="Diverse Opportunities"
                />
                <h4>Diverse Investments</h4>
                <p className="mb-0">
                  Access a wide range of investment avenues across equities,
                  mutual funds, commodities, global markets, and fixed income
                  instruments, enabling balanced diversification through a
                  single integrated account.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="/images/oa-icon2.png"
                  className="img-fluid"
                  alt="Streamlined Trading"
                />
                <h4>Streamlined Trading</h4>
                <p className="mb-0">
                  Execute transactions smoothly with simplified processes,
                  transparent pricing, and reliable order handling designed to
                  support consistent investing and trading experiences.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="/images/oa-icon3.png"
                  className="img-fluid"
                  alt="Portfolio Tracking"
                />
                <h4>Effortless Portfolio Tracking</h4>
                <p className="mb-0">
                  Track your holdings through consolidated portfolio views,
                  performance updates, and timely insights that help you stay
                  aligned with your financial goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a
                href="https://live.meon.co.in/GatewayFInancial/Individual"
                target="_blank"
                rel="noopener noreferrer"
                className="lm-btn"
              >
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/app-pic.jpg"
                className="img-fluid"
                alt="Investment App"
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default OpenAnAccount;
